<template>
    <div class="overall-rating">
        <RatingRangeBar
            v-if="showBar && !pending && overall"
            :width="barWidth"
            :current="overall.ratingValue"
            class="overall-rating-sparkline sparkline"
        />

        <span class="overall-rating-pending" v-if="pending">{{ pendingText }}</span>
        <span class="overall-rating-value" v-else-if="overall">
            {{ overall.ratingValue.toFixed(1) }}
            <sup v-if="overall.group !== 'US'">{{ overall.group }}</sup>
        </span>
        <span class="overall-rating-not-available" v-else v-dialog="noRatingText">N/A</span>
    </div>
</template>

<script setup>
import { NO_RATING_TEXT } from '@/services/ratingsService'
import RatingRangeBar from '@/components/shared/rating-range/rating-range-bar'
import { computed } from 'vue'

const props = defineProps({
    entity: {
        type: Object,
        required: true,
    },
    pendingText: {
        type: String,
        default: 'PENDING',
    },
    showBar: {
        type: Boolean,
        default: false,
    },
    barWidth: {
        type: Number,
        default: 250,
    },
})

const ratings = computed(() => props.entity.ratings)
const overall = computed(() => ratings.value?.overall ?? null)
const pending = computed(() => ratings.value?.pending ?? false)

const noRatingText = computed(() => {
    return NO_RATING_TEXT
})
</script>

<style scoped>
.overall-rating {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: #333333;
    font-family: Lato;
    font-size: 14px;
    line-height: 1;
    text-align: center;

    --dialog-width: 320px;
    --dialog-left: -320px;
}

.overall-rating.medium {
    font-size: 24px;
}

.overall-rating.large {
    font-size: 36px;
}

.overall-rating-sparkline + span {
    display: inline-block;
    text-align: left;
}

.overall-rating-value {
    position: relative;
    white-space: nowrap;
}

sup {
    font-size: 9px;
    opacity: 0.6;
    position: relative;
    top: -2px;
}

.overall-rating.medium sup {
    top: -4px;
}

.overall-rating.large sup {
    margin-left: -4px;
    top: -8px;
}

.overall-rating-value {
    font-weight: 700;
}

.overall-rating-pending,
.overall-rating-not-available {
    font-weight: 400;
}

[data-dialog] [data-dialog-text] {
    width: var(--dialog-width);
}

[data-dialog] [data-dialog-text].left {
    left: var(--dialog-left);
}
</style>
